"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.prevRevisionByFileId = exports.nextRevisionByFileId = exports.getCurrentIndex = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ModelSelector_1 = require("./ModelSelector");
require("./style.scss");
require("./Header.scss");
var getCurrentIndex = function (fileId, revisions) {
    return revisions.findIndex(function (f) { return f.type !== 'FOLDER' && f.file === fileId; });
};
exports.getCurrentIndex = getCurrentIndex;
var nextRevisionByFileId = function (revisions, currentRevision) {
    var index = currentRevision
        ? (0, exports.getCurrentIndex)(currentRevision.file, revisions)
        : 0;
    return revisions[index + 1];
};
exports.nextRevisionByFileId = nextRevisionByFileId;
var prevRevisionByFileId = function (revisions, currentRevision) {
    var index = currentRevision
        ? (0, exports.getCurrentIndex)(currentRevision.file, revisions)
        : 0;
    return revisions[index - 1];
};
exports.prevRevisionByFileId = prevRevisionByFileId;
var Header = function (props) {
    var files = props.files.filter(function (f) { return f.type !== 'FOLDER'; });
    var prevRev = (0, exports.prevRevisionByFileId)(files, props.currentRevision);
    var nextRev = (0, exports.nextRevisionByFileId)(files, props.currentRevision);
    return (React.createElement(sok_ui_1.Grid.Row, { className: 'preview-header-bar' },
        React.createElement(sok_ui_1.Grid.Column, { extraSmall: 12 },
            React.createElement("div", { className: 'preview-header' },
                React.createElement("div", { className: 'left' },
                    React.createElement(sok_ui_1.Button, { disabled: !props.currentRevision, color: "light-blue", icon: React.createElement(Icon_1.Icon, { className: 'fa-arrow-circle-left' }), onClick: props.moveToFolder }),
                    React.createElement(sok_ui_1.Button, { disabled: !prevRev, color: "dark-gray", icon: React.createElement(Icon_1.Icon, { className: 'fa-chevron-left' }), onClick: function () {
                            return prevRev &&
                                prevRev.type !== 'FOLDER' &&
                                props.moveToFile(prevRev.fileUuid, prevRev.uuid);
                        } }),
                    React.createElement(sok_ui_1.Button, { disabled: !nextRev, color: "dark-gray", icon: React.createElement(Icon_1.Icon, { className: 'fa-chevron-right' }), onClick: function () {
                            return nextRev &&
                                nextRev.type !== 'FOLDER' &&
                                props.moveToFile(nextRev.fileUuid, nextRev.uuid);
                        } }),
                    React.createElement("span", { className: "d-none d-tablet-inline" }, props.currentRevision && props.currentRevision.name)),
                React.createElement("div", { className: 'right' },
                    props.currentRevision &&
                        props.currentRevision.preview &&
                        props.currentRevision.preview.conversionService ===
                            'Vektorio' && (React.createElement(ModelSelector_1.default, { currentProject: props.currentProject, currentRevision: props.currentRevision, folderTree: props.folderTree, selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent, clearTree: props.clearTree, selectedRevisions: props.selectedRevisions, setSelectedRevisions: props.setSelectedRevisions })),
                    props.currentRevision && (React.createElement(sok_ui_1.Button, { color: "dark-gray", icon: React.createElement(Icon_1.Icon, { className: 'fa-cloud-download' }), externalUrl: props.currentRevision &&
                            "".concat(__UPLOADSERVERURL__, "/files/").concat(props.currentRevision.uuid) })),
                    React.createElement(sok_ui_1.Button, { color: "dark-gray", icon: React.createElement(Icon_1.Icon, { className: 'fa-expand' }), onClick: function () { return props.toggleFullscreen(); } }),
                    props.showRevisionButton && (React.createElement(sok_ui_1.Button, { border: "yellow", color: props.showRevisionList ? 'black' : 'dark-gray', onClick: function () {
                            return props.setShowRevisionList(!props.showRevisionList);
                        }, text: React.createElement("span", { className: "d-none d-tablet-none d-desktop-inline" }, (0, translation_1.getLocalization)('filesPreview/header/revision')), icon: React.createElement(Icon_1.Icon, { className: "fa-history" }) })))))));
};
exports.Header = Header;
